import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { AuthShell } from "./Login";

export default function Register() {
  const { register } = useAuth();
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }
    setBusy(true);
    try {
      await register(email, password, fullName);
      toast.success("Account created — let's get you a ticket");
      navigate("/checkout", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Registration failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Create Account" subtitle="Buy PPV & watch the fight">
      <form onSubmit={submit} className="space-y-5" data-testid="register-form">
        <div>
          <label className="eyebrow block mb-2">Full Name</label>
          <input
            required
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            className="flat"
            data-testid="register-name-input"
            autoComplete="name"
          />
        </div>
        <div>
          <label className="eyebrow block mb-2">Email</label>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="flat"
            data-testid="register-email-input"
            autoComplete="email"
          />
        </div>
        <div>
          <label className="eyebrow block mb-2">Password</label>
          <input
            type="password"
            required
            minLength={6}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="flat"
            data-testid="register-password-input"
            autoComplete="new-password"
          />
          <p className="mt-2 text-xs text-zinc-500">At least 6 characters.</p>
        </div>
        <button
          type="submit"
          disabled={busy}
          className="btn-primary w-full py-4 text-sm flex items-center justify-center gap-2 disabled:opacity-60"
          data-testid="register-submit-btn"
        >
          {busy && <Loader2 className="animate-spin" size={18} />}
          Create Account
        </button>
      </form>
      <p className="mt-6 text-sm text-zinc-400">
        Already have one?{" "}
        <Link to="/login" className="text-rose-500 underline" data-testid="link-to-login">
          Sign in
        </Link>
      </p>
    </AuthShell>
  );
}
